














































import { Prop, Component, Vue } from "vue-property-decorator";
import IReportSceneOutput from "@/api/models/IReportSceneOutput";

@Component({})
export default class ReportSceneControl extends Vue {
  @Prop({ required: true }) scene!: IReportSceneOutput;

  maxLength = 80;

  changePhoto() {
    this.$emit("changePhoto", this.scene);
  }
}
